// This file is for helpers that relate to any form validation within the application

import * as R from 'ramda';

// Helpers
import { ALPHANUMERIC, GT_ZERO, INTEGER, REQUIRED } from './validationMessages';

export const isNotEmpty = R.complement(R.isEmpty);
export const isInt = n => +n === parseInt(n);

// checks for authorizationNumber in supplierAuth
// \W is for all non alphanumeric characters
export const isSpecialChar = str => /\W/g.test(str);
export const isLessThan = (str, value) => R.lte(R.length(str), value);
export const isNumber = str => /^\d+$/.test(str);
export const isNumberWithOptionalFormatting = str => /^(\d+|\d{1,3}(,\d{3})*)$/.test(str);

// Required integers greater than 0
// validateIntGTZero :: String -> String
export const validateIntGTZero = R.cond([
  [R.isEmpty, R.always(REQUIRED)],
  [R.complement(isInt), R.always(INTEGER)],
  [R.gt(1), R.always(GT_ZERO)],
  [R.T, R.always('')],
]);

// Required Alpha Numeric is required and must be alphanumeric
// validateRequiredAlphaNumeric :: String -> String
export const validateRequiredAlphaNumeric = R.cond([
  [R.isEmpty, R.always(REQUIRED)],
  [isSpecialChar, R.always(ALPHANUMERIC)],
  [R.T, R.always('')],
]);
export const validateAlphaNumeric = R.cond([
  [isSpecialChar, R.always(ALPHANUMERIC)],
  [R.T, R.always('')],
]);

// Required Autocomplete is field must not be empty/undefined
// validateRequiredAutocomplete :: String -> String
export const validateRequiredAutocomplete = R.ifElse(R.isNil, R.always(REQUIRED), R.always(''));
